export default __webpack_public_path__ + "static/media/logo-footer.62163270.png";